/*
 * @Author: caiqin.xie
 * @since: 2023-10-19 16:59:17
 * @lastTime: 2023-10-25 16:33:06
 * @LastEditors: caiqin.xie
 * @message: 轮播组件
 */
import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper';

// Import Swiper styles
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

import styles from "./index.module.scss";
import classNames from 'classnames';

interface IProps {
  children?: any; // slots
  swiperSlideClass?: string; // swiperSlide className
  swiperWrapClass?: string; // swiperWrap className
  breakpoints?: Record<string, any>; // 响应式
  autoplay?: any; // 自动播放 默认否
  loop?: boolean; // 是否循环 默认否
  slidesPerView?: number; // 每屏显示多少 默认auto
  centeredSlides?: boolean; // 是否居中 默认否
  spaceBetween?: number; // 间距 默认24
  setSwiper?: (swiper: any) => void; // 获取swiper实例 处理swiper事件
  isHidePagination?: boolean; // 是否隐藏分页器 默认true
  isShowNavigation?: boolean; // 是否隐藏导航 默认false
}

export default (props: IProps) => {
  const {
    children,
    swiperSlideClass,
    swiperWrapClass,
    breakpoints,
    autoplay,
    loop,
    slidesPerView,
    centeredSlides,
    spaceBetween,
    setSwiper,
    isHidePagination,
    isShowNavigation
  } = props

  return (
    <>
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        slidesPerView={slidesPerView ?? 'auto'}
        onSwiper={(swiper) => setSwiper && setSwiper(swiper)}
        className={classNames(swiperWrapClass, {
          [styles['hide-pagination']]: isHidePagination ?? true
        })}
        breakpoints={breakpoints}
        autoplay={autoplay ?? false}
        loop={loop ?? false}
        centeredSlides={centeredSlides ?? false}
        spaceBetween= {spaceBetween ?? 24}
        pagination={{ clickable: true }}
        navigation={isShowNavigation ?? false}
      >
        {children && children.map((child: any, index: number) => (
          <SwiperSlide className={swiperSlideClass} key={index}>{child}</SwiperSlide>
        ))}

      {/* <div className={classNames('swiper-button-prev', styles['swiper-btn'])}></div>
      <div className={classNames('swiper-button-next', styles['swiper-btn'])}></div> */}

      </Swiper>
      
    </>
    
  );
};